import { ARC_START_ANGLE } from '../constants.js';
import { useGaugeChartAspectRatio } from '../hooks/useGaugeChartAspectRatio.js';
import { buildArc } from '../utils/build-arc.js';
import { calculateGaugeAngle } from '../utils/calculate-gauge-angle.js';

/**
 * @internal
 */
interface GaugeValueArcProps {
  color: string;
  min: number;
  max: number;
  value: number;
}

/**
 * @internal
 */
export const GaugeValueArc = ({
  color,
  value,
  min,
  max,
}: GaugeValueArcProps) => {
  const { arcOuterRadius, arcInnerRadius } = useGaugeChartAspectRatio();

  const currentValueEndAngle = calculateGaugeAngle(value, max, min);

  const gaugeCurrentValueD = buildArc(
    arcInnerRadius,
    arcOuterRadius,
    ARC_START_ANGLE,
    currentValueEndAngle,
  );

  return <path d={gaugeCurrentValueD} fill={color} />;
};
